import React, {useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import UserPlaceholder from '../../assets/user-placeholder.png';
import { useNavigate } from 'react-router-dom';

const HamburgerMenu = ({ setShowHamburgerMenu, isLoggedIn, userData, dropdownRef, handleSignOut, processing }) => {

    const navigate = useNavigate();

    return (
        <div 
            className="d-flex flex-column"
            id='hamburger-menu' 
            style={{
                position: 'fixed', 
                top: '0', 
                left: '30%',
                width: '100%',
                height: 'calc(100dvh - env(safe-area-inset-bottom, 0px))', // Dynamic height
                backgroundColor: '#0a0f16', 
                padding: '15px 0px',
                borderLeft: '1px solid #3c3e4c',
                // borderRadius: '8px', 
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
                zIndex: 1000,
            }}
            ref={dropdownRef}
            >
            <FontAwesomeIcon className='ps-2' icon={faCircleXmark} style={{ color: "white", width: "25px", height: "25px", cursor: "pointer" }} onClick={() => setShowHamburgerMenu(false)}/>
            <div>
                {isLoggedIn ? (
                <div className="user-menu d-flex align-items-center mt-3 mb-3 ps-4" ref={dropdownRef}>
                    <img
                    src={UserPlaceholder}
                    alt="User"
                    className="user-placeholder"
                    onClick={() => navigate('/profile')}
                    style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        cursor: 'pointer',
                    }}
                    />
                    <div className='ms-3 mt-2'>
                    <p className='microtext'>{userData?.contributorType || "Smash Cadet"}</p>
                    <h4>{userData.username}</h4>
                    </div>
                </div>
                ) : (
                <div className="user-menu d-flex align-items-center mt-3 mb-3 ps-4" ref={dropdownRef}>
                    <img
                    src={UserPlaceholder}
                    alt="User"
                    className="user-placeholder"
                    // onClick={toggleDropdown}
                    style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        // cursor: 'pointer',
                    }}
                    />
                    <div className='ms-3'>
                    <h4>{userData?.username || "Welcome, Guest"}</h4>
                    <p className='microtext'><span style={{cursor: 'pointer', fontWeight: '400', color: '#FFCC19'}} onClick={() => {navigate('/register'); setShowHamburgerMenu(false);}}>Register</span> for full access</p>
                    </div>
                </div>
                )}
            </div>
            <hr />
            <div className='menu-items' style={{ height: '80vh' }}>
                <div className='d-flex flex-column gap-4 mt-2 ps-4'>
                <a href="/tutorials/foundation" style={{color: 'white', textDecoration: 'none', marginBottom: '0px', fontSize: '18px'}} onClick={() => setShowHamburgerMenu(false)}>Tutorials</a>
                {/* <hr /> */}
                <a href="/resources" style={{color: 'white', textDecoration: 'none', marginBottom: '0px', fontSize: '18px'}} onClick={() => setShowHamburgerMenu(false)}>Resources</a>
                {/* <hr /> */}
                <a href="/pricing" style={{color: 'white', textDecoration: 'none', marginBottom: '0px', fontSize: '18px'}} onClick={() => setShowHamburgerMenu(false)}>Pricing</a>
                </div>
                {/* <hr /> */}
                {isLoggedIn ? (
                <div className='d-flex flex-column gap-4 mt-4 ps-4' style={{marginBottom: 'calc(env(safe-area-inset-bottom, 80px))'}}>
                    {/* <a href="/profile" style={{color: 'white', textDecoration: 'none', marginBottom: '0px', fontSize: '18px'}} onClick={() => setShowHamburgerMenu(false)}>Profile</a> */}
                    <a href="" style={{color: 'white', textDecoration: 'none', marginBottom: '0px', fontSize: '18px'}} onClick={() => {navigate('/support'); setShowHamburgerMenu(false);}}>Help / Support</a>
                    <button style={{ color: "#FFCC19", background: 'none', border: 'none', padding: '0', fontSize: '18px', textAlign: 'left' }} disabled={processing} onClick={() => {handleSignOut(); setShowHamburgerMenu(false);}}>Sign Out</button>
                </div>
                ) : (
                <div className='d-flex flex-column gap-4 mt-4 ps-4' style={{marginBottom: 'calc(env(safe-area-inset-bottom, 80px))'}}>
                    <a href="" style={{color: 'white', textDecoration: 'none', marginBottom: '0px', fontSize: '18px'}} onClick={() => {navigate('/support'); setShowHamburgerMenu(false);}}>Help / Support</a>
                    <button style={{ color: "#FFCC19", background: 'none', border: 'none', padding: '0', fontSize: '18px', textAlign: 'left' }} onClick={() => {navigate('/login'); setShowHamburgerMenu(false);}}>Sign In</button>
                </div>
                )}
            </div>
        </div>
    )
}

export default HamburgerMenu